export default __webpack_public_path__ + "static/media/Pollinate-White-Full-Logo.25223692.svg";